module.exports = __webpack_public_path__ + "img/hrotka.456b0074.jpg";